import React from 'react';

const HeaderLogo = () => (
  <div className="pb-8">
    <a href="/">
      <img
        className="w-48 h-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        src="/assets/common/images/logos/unified/sb-logo.svg"
        alt="Storyblocks"
        width={150}
        height={32}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            window.location.href = '/';
          }
        }}
      />
    </a>
  </div>
);

export default HeaderLogo;
